import * as React from "react";
import { navigate } from "~/router";
import { Overlay, SideModal, SideModalContent } from "~/common/layout/Modals";
import Head from "~/common/layout/Head";
import ProductSegmentForm from "../../components/products/ProductSegmentForm";
import { useEditProductCategory, useProductCategoryById } from "~/apps/pos/apis/productCategories";
import { ProductSegmentReq } from "~/apps/pos/models";

const ProductCategoryEditPopup = ({ categoryId }) => {
  const { data: category, isLoading: getCategoryLoading } = useProductCategoryById(categoryId);
  const { mutate: onEdit, error, isLoading: editCategoryLoading } = useEditProductCategory();

  const handleClose = () => {
    navigate("pos.admin.products.categories");
  };

  const handleSubmit = (data: ProductSegmentReq) => {
    onEdit(data, {
      onSuccess: () => {
        handleClose();
      },
    });
  };

  const initialValues = {
    id: category?.id || "",
    name: category?.name || "",
  };

  return (
    <Overlay onClick={handleClose} isLoading={getCategoryLoading || editCategoryLoading}>
      <SideModal>
        <Head headTitle={`Edit category - ${category?.name}`} />
        <SideModalContent>
          <ProductSegmentForm
            initialValues={initialValues}
            error={error?.message || error?.errorMessage || ""}
            onSubmit={handleSubmit}
            onClose={handleClose}
          />
        </SideModalContent>
      </SideModal>
    </Overlay>
  );
};

export default ProductCategoryEditPopup;
